

export class ObjectData {

  ID: number;
  AccountManager: number;
  ContactPersoon: number;
  BedrijfNummer: number;
  InvoerDatum: string ;
  ObjectNummer: number;
  ObjectSerieNr: number;
  Object: string;
  Oplage: string;
  Omvang: string;
  Druk: string;
  Papier: string;
  PlanoFormaat: string;
  AfgewerktFormaat: string;
  Afwerking: string;
  Verpakking: string;
  Opmerking: string;
  OfferteOp: string;
  LeverDatum: string;
  LeverDatumTekst: string;
  FaseID: number;
  FaseDatum: string;
  MutatieDatum: string;
  ImportObjectNummer: string;
  facturenid : number;
  offertesid : number;
  Factuurnummer: string;
  Offertenummer: string;
}

export class ObjectStatus {
	ID: number;
	ObjectID: number;
	StatusCodeID: number;
	Omschrijving: string;
	BedrijfNummer: number;
	DatumHeen: string;
	DatumTerug: string;
	KostenEuro: number;
	InvoerDatum: string;
	MutatieDatum: string;
}

export class ObjectRapportDetails {
  Relatie:string;
  Contactpersoon:string;
  Object:string;
  ObjectNr:string;
  FaktuurDatum : string;
  FaktuurNummer : string;
  TotaalBedragEuro : number
}

//todo:  Aanpassen
export class ObjectAfleveradres {
	ID: number;
  AfleverAdresID: number;
  ObjectID:number;
  InvoerDatum: string;
}
